import * as Karla from './Karla/face.css';
import * as RobotoMono from './RobotoMono/face.css';

export const global = `
${Karla}
${RobotoMono}
`;
